<div class="generic-modal row" tabindex="0">
  <div class="col-12 auto-center">
    <img class="img-alert" src="assets/img/ko.png" alt="icon ko" />
    <p class="info-text modal-text" [innerHtml]="'error_modal_tpv' | translate"></p>
  </div>

  <button id="modal-generic-confirm" class="btn btn-02 btn-modal" type="submit" (click)="accept()" id="btn-accept">
    {{ 'btn_error_modal_tpv' | translate }}
  </button>
</div>
